import {ChangeDetectorRef, Component, OnInit, Renderer2, ViewChild} from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import * as XLSX from 'xlsx';
import {CourseService} from '../../shared/course.service';
import {RosterService} from '../../shared/roster.service';
import {CourseList} from '../../shared/interface/course.interface';
import {Roster, Student, StudentAddComment} from '../../shared/interface/roster.interface';
import {CourseCacheService} from '../../shared/course-cache.service';
import {GradingRuleService} from '../../shared/grading-rule.service';
import {CourseChangeLogService} from '../../shared/course-change-log.service';
import {GradeStatementService} from '../../shared/grade-statement.service';
import {
    GradeStatement,
    GradeStatementList,
    GradeStatementOption
} from '../../shared/interface/grade-statement.interface';
import {GenericFormGroupComponent} from '../../forms/generic-form-group.component';
import {MatAccordion} from '@angular/material/expansion';
import {GradeStatementScenarioType} from '../../shared/enum/grade-statement-scenario-type';
import {GradeStatementOptionMessageType} from '../../shared/enum/grade-statement-option-message-type';
import {GradeUploadStatData} from '../../shared/interface/grade-upload-stat.interface';
import {GradeType} from "../../shared/enum/grade-type";
import {UcrSecurityService} from "../../core/ucr-security/ucr-security.service";
import {UserInfo} from "../../core/ucr-security/user-info";

@Component({
    selector: 'app-roster-upload-grades',
    templateUrl: './upload-grades.component.html',
    styleUrls: ['./upload-grades.component.scss']
})
export class UploadGradesComponent extends GenericFormGroupComponent implements OnInit {
    private userInfo: UserInfo;

    constructor(
        private route: ActivatedRoute,
        public router: Router,
        public courseService: CourseService,
        public rosterService: RosterService,
        public courseCacheService: CourseCacheService,
        public gradingRuleService: GradingRuleService,
        public courseChangeLogService: CourseChangeLogService,
        public gradeStatementService: GradeStatementService,
        private changeDetectRef: ChangeDetectorRef,
        protected renderer2: Renderer2,
        private security: UcrSecurityService
    ) {
        super(renderer2);
        this.security.getUserInfo().subscribe((ui) => {
            this.userInfo = ui;
        });
    }

    loading: boolean = false;
    termCode: string;
    crn: string;
    numRecordPreview: number = 5;
    file: any = null;
    fileContentJson: any = [];
    fileContentNonJson: any = [];
    fileColumnNames: any = [];
    needToDisplaySelectHeader: boolean = false;
    previewResult: boolean = false;
    isIDSelected: boolean = false;
    isIGradeSelected: boolean = false;
    selectedIDColumn: any = null;
    selectedIGradeColumn: any = null;
    doesColumnHeadExists: boolean = false;
    showCancelMessage: boolean = false;
    uploadGradeLog: any = [];
    gradeStatementList: GradeStatementList;
    studentListNeedConfirm: any = [];
    studentListToUpdateGrade: Student[] = [];

    //stats

    gradeUploadStatData: GradeUploadStatData = {
        numberOfStudentInFile: 0,
        numberStudentExistsInRoster: 0,
        numberStudentNotExistsInRoster: 0,
        numberStudentWithGradeChange: 0,
        numberStudentWithNoGradeChange: 0
    };

    @ViewChild(MatAccordion) accordion: MatAccordion;
    readonly gradeStatementScenarioType: GradeStatementScenarioType = GradeStatementScenarioType.getInstance();
    readonly gradeStatementOptionMessageType: GradeStatementOptionMessageType =
        GradeStatementOptionMessageType.getInstance();
    readonly gradeType: GradeType = GradeType.getInstance();

    ngOnInit(): void {
        this.loading = true;
        this.termCode = this.route.snapshot.paramMap.get('termCode');
        this.crn = this.route.snapshot.paramMap.get('crn');
        if (!this.courseService.currentCourse) {
            this.courseService.getByCRN(this.termCode, this.crn).subscribe((response: CourseList) => {
                if (response.list.length > 0) {
                    let course = response.list[0];

                    if (this.userInfo) {
                        if (
                            response?.list?.find((m) => {
                                return m.instructorNetId === this.userInfo.username;
                            })
                        ) {
                            course = response?.list?.find((m) => {
                                return m.instructorNetId === this.userInfo.username;
                            });

                        }
                    }

                    this.courseService.setCurrentCourse(course);
                }
            });
        }
        this.rosterService.get(this.termCode, this.crn).subscribe((response: Roster) => {
            this.rosterService.setCurrentRoster(response);
        });
        this.gradeStatementService.get().subscribe((response: GradeStatementList) => {
            this.gradeStatementList = response;
        });
    }

    reInitData(): void {
        this.file = null;
        this.fileContentJson = [];
        this.fileContentNonJson = [];
        this.fileColumnNames = [];
        this.needToDisplaySelectHeader = false;
        this.previewResult = false;
        this.isIDSelected = false;
        this.isIGradeSelected = false;
        this.selectedIDColumn = null;
        this.selectedIGradeColumn = null;
        this.doesColumnHeadExists = false;
        this.showCancelMessage = false;

    }

    reInitStatData(): void {

        this.gradeUploadStatData = {
            numberOfStudentInFile: 0,
            numberStudentExistsInRoster: 0,
            numberStudentNotExistsInRoster: 0,
            numberStudentWithGradeChange: 0,
            numberStudentWithNoGradeChange: 0
        };
    }

    getHeaderRow(sheet: any) {
        const headers = [];
        const range = XLSX.utils.decode_range(sheet['!ref']);
        let C,
            R = range.s.r; /* start in the first row */
        /* walk every column in the range */
        for (C = range.s.c; C <= range.e.c; ++C) {
            const cell = sheet[XLSX.utils.encode_cell({c: C, r: R})]; /* find the cell in the first row */

            let hdr = 'UNKNOWN ' + C; // <-- replace with your desired default
            if (cell && cell.t) hdr = XLSX.utils.format_cell(cell);

            headers.push(hdr);
        }
        return headers;
    }

    processFile(e: any): void {
        //need to reset flags when re-upload
        while (!this.rosterService.currentRoster) {
        }

        this.reInitData();

        this.file = e.target.files[0];
        let workBook = null;
        let jsonData = null;
        const reader = new FileReader();
        // load data
        reader.onload = (e) => {
            const data = reader.result.toString();
            workBook = XLSX.read(data, {type: 'binary'});
            jsonData = workBook.SheetNames.reduce((initial, name) => {
                const sheet = workBook.Sheets[name];
                this.fileColumnNames = this.getHeaderRow(sheet);
                this.fileContentNonJson = sheet;
                initial[name] = XLSX.utils.sheet_to_json(sheet);
                this.fileContentJson = initial[name];
                return initial;
            }, {});
        };
        reader.readAsBinaryString(this.file);

        //after loading process the data
        reader.onloadend = (e) => {
            this.needToDisplaySelectHeader = true;
            if (this.fileColumnNames) {
                this.doesColumnHeadExists = true;
            } else {
                this.doesColumnHeadExists = false;
            }

            // after loading we can process
            // need to also test CSV
            // populate the colums to allow user to select what column as the id (NETID/SID)
            // what column has the grades
            // and what column has any comments (new) to upload
            // if it cannot auto recognized based on column header we will ask.
        };
    }

    findStudentInRoster(jsonData: any, idColumnName: string): Student {
        const iD = jsonData[idColumnName]?.toString().toLowerCase(); // get ID

        const student: Student = this.rosterService.currentRoster.roster.find(
            (element: Student) =>
                element.studentId?.toString().toLowerCase() === iD || element.netId?.toString().toLowerCase() === iD
        );
        return student;
    }

    updateStudentGradeUploadStat(checkGradeChange: boolean = false): void {
        this.reInitStatData();

        const idColumnName = this.fileColumnNames[this.selectedIDColumn];
        const idColumnGrade = this.fileColumnNames[this.selectedIGradeColumn];
        const gradingRuleService = this.gradingRuleService;

        this.fileContentJson.forEach((x) => {
            if (x.hasOwnProperty(idColumnName)) {
                const student: Student = this.findStudentInRoster(x, idColumnName);
                this.gradeUploadStatData.numberOfStudentInFile++;

                //if find
                if (student) {
                    this.gradeUploadStatData.numberStudentExistsInRoster++;
                    //if matches we check grade change
                    if (checkGradeChange && this.selectedIGradeColumn) {
                        const grade = x[idColumnGrade]?.toString()?.trim()?.toUpperCase(); // GET THE GRADE
                        if (student.gradeIGrade !== grade && student.gradeBanner !== this.gradeType.gradeW) {
                            //is the assigned grade valid
                            if (gradingRuleService.isValidGrade(student.gradeRule, student.gradeType, grade)) {
                                this.gradeUploadStatData.numberStudentWithGradeChange++;
                            } else {
                                this.gradeUploadStatData.numberStudentWithNoGradeChange++;
                            }
                        } else {
                            this.gradeUploadStatData.numberStudentWithNoGradeChange++;
                        }
                    }
                } else {
                    this.gradeUploadStatData.numberStudentNotExistsInRoster++;
                }
            }
        });

        console.log(this.gradeUploadStatData.numberOfStudentInFile);
        console.log(this.gradeUploadStatData.numberStudentExistsInRoster);
        console.log(this.gradeUploadStatData.numberStudentNotExistsInRoster);
        console.log(this.gradeUploadStatData.numberStudentWithGradeChange);
        console.log(this.gradeUploadStatData.numberStudentWithNoGradeChange);
    }

    setPreview(): void {
        // check to see if we have selected a column

        //set if ID is selected to display id data
        if (this.selectedIDColumn) {
            this.isIDSelected = true;
            this.updateStudentGradeUploadStat();
        } else {
            this.isIDSelected = false;
        }

        // set if igrade is selecte to display data
        if (this.selectedIGradeColumn) {
            this.isIGradeSelected = true;

            //only check grade match if we have id column as well
            if (this.selectedIDColumn) {
                this.updateStudentGradeUploadStat(true);
            }
        } else {
            this.isIGradeSelected = false;
        }

        // if any data is selected show preview part
        if (this.isIDSelected || this.isIGradeSelected) {
            this.previewResult = true;
        } else {
            this.previewResult = false;
        }
    }

    //confirm to process grade
    confirmUploadGrade(): void {
        console.log('confirmUploadGrade');
        const idColumn = this.selectedIDColumn;
        const gradeColumn = this.selectedIGradeColumn;
        const columnNames = this.fileColumnNames;
        const currentRoster = this.rosterService.currentRoster;
        const gradingRuleService = this.gradingRuleService;
        const uploadGradeLog = this.uploadGradeLog;
        const gradeStatementService = this.gradeStatementService;
        const gradeStatementList = this.gradeStatementList;
        const studentListNeedConfirm = this.studentListNeedConfirm;
        const studentListToUpdateGrade = this.studentListToUpdateGrade;

        // go though all file json content and check each item
        this.fileContentJson.forEach(function (item) {
            const iD = item[columnNames[idColumn]]?.toString().toLowerCase(); // get ID
            const grade = item[columnNames[gradeColumn]]?.toString()?.trim()?.toUpperCase(); // GET THE GRADE
            //get student
            const student: Student = currentRoster.roster.find(
                (element: Student) =>
                    element.studentId?.toString().toLowerCase() === iD || element.netId?.toString().toLowerCase() === iD
            );

            if (student) {
                // found student let's check

                if (student.gradeIGrade !== grade) {
                    //is the assigned grade valid
                    if (gradingRuleService.isValidGrade(student.gradeRule, student.gradeType, grade)) {
                        //grade is valid set up grade
                        const oldGrade = student.gradeOriginalIGrade;
                        student.gradeIGrade = grade;
                        //we may need to rollback
                        const statement: GradeStatement = gradeStatementService.findStatement(
                            student,
                            gradeStatementList
                        );
                        if (statement) {
                            //if we have statement we need a list of student and who
                            student.gradeResponse = {
                                agree: false,
                                gradeStatementOptionId: -1,
                                selectedMessageType: null,
                                selectedGradeStatementScenarioType: null
                            };
                            studentListNeedConfirm.push({
                                student: student,
                                oldGrade: oldGrade,
                                newGrade: grade,
                                statement: statement
                            });
                            uploadGradeLog.push({
                                id: iD,
                                message:
                                    'Grade has not been changed from ' +
                                    oldGrade +
                                    ' to ' +
                                    grade +
                                    ' because GD or Incomplete grade issued.  Additional confirmation required.'
                            });
                            //temporary revert the grade change
                            student.gradeIGrade = oldGrade;
                        } else {
                            uploadGradeLog.push({
                                id: iD,
                                message: 'Grade has been changed from ' + oldGrade + ' to ' + grade + '.'
                            });
                            studentListToUpdateGrade.push(student);
                        }
                    } else {
                        uploadGradeLog.push({
                            id: iD,
                            message: 'Grade ' + grade + ' is not a valid grade.'
                        });
                    }
                } else {
                    // log no chagne
                    uploadGradeLog.push({
                        id: iD,
                        message: 'No Grade change from ' + student.gradeIGrade + ' to ' + grade + '.'
                    });
                }
            } else {
                uploadGradeLog.push({
                    id: iD,
                    message: 'Unable to locate the student with ID ' + iD + '.'
                });
            }
        });

        this.rosterService.currentRoster = currentRoster;
        this.showCancelMessage = false;

        this.courseChangeLogService
            .save(this.courseService.currentCourse.id, this.uploadGradeLog)
            .subscribe((response: any) => {
                console.log(response);
            });
        this.rosterService.update(currentRoster.id, studentListToUpdateGrade).subscribe((response: Roster) => {
            this.rosterService.setCurrentRoster(response); //this will also do the sort
            // after done go back to roster
            if (studentListNeedConfirm?.length == 0) {
                this.router.navigateByUrl('/home/roster/' + this.termCode + '/' + this.crn);
            }

            //after update
            //show the list of student need agreement
        });
    }

    cancelUploadGrade(): void {
        this.reInitData();
        this.showCancelMessage = true;
    }

    canExpand(student: Student, statement: GradeStatement) {
        if (
            statement.gradeStatementText.gradeStatementOption &&
            student.gradeResponse.gradeStatementOptionId > 0 &&
            student.gradeResponse.agree
        ) {
            return false;
        } else {
            if (!statement.gradeStatementText.gradeStatementOption && student.gradeResponse.agree) {
                return false;
            }
        }

        return true;
    }

    canSubmit(list: any) {
        if (list?.length == 0) {
            return false;
        }

        if (
            list.filter((item: any) => {
                return this.canExpand(item?.student, item?.statement);
            })?.length > 0
        ) {
            return false;
        } else {
            return true;
        }
    }

    returnHome() {
        this.router.navigateByUrl('/home/roster/' + this.termCode + '/' + this.crn);
    }

    //add notes to the list
    addNotes(student: Student, canDelete: boolean = true) {
        //call service to pull the data and update the comment information
        this.rosterService.addOneStudentComment(student, canDelete).subscribe((response: StudentAddComment) => {
            student.tempComment = null;
        });
    }

    submitAgreeStudentList(processList: any) {
        //before we post need to add GD statement
        //add log agree
        const studentList: Student[] = [];
        let addRecord: boolean = true;

        processList.forEach((processRec: any) => {
            console.log(processRec);
            processRec.student.gradeIGrade = processRec.newGrade;

            //find if there is a change code if not don't proceed
            if (processRec.student.shrtckgGCHGCode) {
                const optionSelected = processRec.statement.gradeStatementText.gradeStatementOption.find(
                    (item: GradeStatementOption) => {
                        return item.id === processRec.student.gradeResponse.gradeStatementOptionId;
                    }
                );
                processRec.student.gradeResponse.selectedMessageType = optionSelected.messageType;

                if (
                    optionSelected.messageType ==
                    this.gradeStatementOptionMessageType.PastStudentWorkCompleteAfterExtension
                ) {
                    processRec.student.gradeIGrade = processRec.student.oldGrade;
                    processRec.student.gradeResponse.gradeStatementOptionId = null;
                    addRecord = false;
                } else {
                    processRec.student.tempComment = optionSelected.statement;
                    this.addNotes(processRec.student, false);
                }
            }

            if (addRecord) {
                studentList.push(processRec.student);
            }
        });

        if (studentList?.length > 0) {
            this.rosterService
                .update(this.rosterService.currentRoster.id, studentList)
                .subscribe((response: Roster) => {
                    this.returnHome();
                });
        } else {
            this.returnHome();
        }
    }
}
